import { createMuiTheme } from '@material-ui/core';
import { overrides } from './overrides';
import { palette } from './palette';
import shadows from './shadows';
import typography from './typography';
import { JupiterTheme } from './types';

const nonOverrideTheme = createMuiTheme({
  palette,
  typography,
  shadows,
} as any) as JupiterTheme;

export const theme = createMuiTheme({
  palette: palette,
  typography,
  shadows,
  overrides: overrides(nonOverrideTheme),
  animationDuration: (duration: string | number) => {
    return process.env.STORYBOOK_HOOK_MOCKS ? 0 : duration;
  },
  displayGif: (gif: string) => {
    return process.env.STORYBOOK_HOOK_MOCKS ? '' : gif;
  },
} as any) as JupiterTheme;
